export * from "./client-locations";
export * from "./html-storage-location.enum";
export * from "./memory-storage.service";
export * from "./serialized-memory-storage.service";
export * from "./storage-location";
export * from "./storage-location.enum";
export * from "./storage-options";
export * from "./storage-service.provider";
// Renamed to just "StorageService", to be removed when references are updated
export { StorageService as AbstractStorageService } from "./storage.service";
export * from "./storage.service";
